var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigLaunch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: "1821px",
    height: "1321px",
    viewBox: "0 0 1821 1321",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "big-launch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created by Webpixels.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "big-launch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.2,441.3 C218,245.6 373.2,71.1 581.8,143.7 C802.8,220.6 786.1,395.2 885.7,451.9 C985.2,508.6 1358.7,313.6 1550.1,486.2 C1658.3,583.7 1662.7,666.2 1595.5,778.7 C1547.9,858.4 1414.2,989.7 1085.3,989.7 C849.9,989.7 782.1,1094.8 606.8,1229.9 C380,1404.6 241.7,1296.7 323.3,1012.5 C400,745.2 289.1,739.9 246.2,441.3 Z",
    id: "Path",
    fill: "#F1F2F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.8,680.8 C908.8,680.8 739.7,664.2 700,672.2 C660.3,680.2 765.3,929.6 765.3,929.6 L817.6,912.6 L774.5,745.1 C774.5,745.1 881.6,791.3 990.2,778.6 C990.2,778.6 989.4,705.7 908.8,680.8 Z",
    id: "Path",
    fill: "#37B37F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.5,1064 L1298.4,1069.7 C1298.4,1069.7 1310.1,1122.2 1289.3,1158 C1268.5,1193.8 1244.3,1211 1216.4,1218 L1187.7,1172.8 L1254.5,1064 Z",
    id: "Path",
    fill: "#283444",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.5,755.3 C742.8,678 745.6,616.7 745.7,610 C753.5,615.8 757.3,619.2 757.3,619.2 L1259.5,1032.6 C1281.6,1189.4 1146.4,1212.7 1146.4,1212.7 C1146.4,1212.7 765.5,1012.6 562.5,839.1 C570.2,838.6 638.3,832.4 690.5,755.3 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.4,1012.7 L1259.5,1032.5 C1281.6,1189.3 1146.4,1212.6 1146.4,1212.6 C1146.4,1212.6 1135.5,1206.9 1116.3,1196.5",
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.3,481 C576.9,497.5 707.8,581.8 745.7,610 C745.5,616.7 742.7,678 690.5,755.3 C638.3,832.5 570.2,838.6 562.4,839.1 C562.3,839 562.1,838.9 562,838.7 C359,665.1 345.3,481 345.3,481 Z",
    id: "Path",
    fill: "#FE8163",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2443ac",
    fillRule: "nonzero",
    points: "1399.5 1016.6 1394.9 1001.8 1184.7 814.7 986.3 807.7 1023.2 840.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero",
    points: "813.1 939 820.2 975.7 795.3 983.2 777.2 943.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2443ac",
    fillRule: "nonzero",
    points: "1180.2 1314.3 1175.6 1320.1 910.5 1201.9 816.1 1020.7 861.3 1044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.5,1016.6 L1186,832 L1023.3,840.1 L1235.7,1012.4 C1235.7,1012.3 1291.1,994.6 1399.5,1016.6 Z",
    id: "Path",
    fill: "#e5c15c",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.4,1191 C1112.4,1191 1140.9,1266.8 1180.2,1314.3 L922.4,1197.3 L861.3,1044 L1112.4,1191 Z",
    id: "Path",
    fill: "#e5c15c",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2443ac",
    fillRule: "nonzero",
    points: "1246.1 1223.8 1239.8 1230.9 1016.5 1081.6 912.6 990.2 946.1 955.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.6,1109.9 C1171.6,1109.9 1221.7,1171.4 1246.1,1223.8 L1025.2,1072.4 L946,955.9 L1171.6,1109.9 Z",
    id: "Path",
    fill: "#e5c15c",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.2,778.6 C990.2,778.6 978.1,796.8 784.4,784.6 C784.4,784.6 815,894 825,946.7 L756.8,961.7 C756.8,961.7 697,780.6 697.199499,756 C697.4,731.4 715.8,721.9 764.9,709.1 C814,696.3 906.3,681.4 906.3,681.4 C906.3,681.4 967.2,696.2 980.2,722.6 C993.1,749.1 990.2,778.6 990.2,778.6 Z",
    id: "Path",
    fill: "#37B37F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero",
    points: "1085.7 513.9 1087.4 482.9 1071.7 483 1057 508.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.1,489 C1087.1,489 1113.7,480.7 1126.1,448.5 C1138.6,416.3 1108.5,396.5 1085.9,402.1 C1063.3,407.7 1045,457.7 1043.4,463.9 C1041.8,470.2 1031,498.5 1087.1,489 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.6,412.4 C1070.6,412.4 1068.8,394.7 1097.7,390.8 C1126.5,386.9 1137.4,434.7 1172.2,446.1 C1206.9,457.5 1240.3,455.3 1267.4,480.6 C1294.5,505.8 1297.6,533.3 1296.7,556.8 C1295.9,580.3 1274.4,561.4 1266.7,583.3 C1259,605.2 1237,593.7 1232.7,602.4 C1228.4,611.1 1204.8,652.1 1190.3,625.9 C1175.8,599.7 1176.5,573.8 1144.9,559.8 C1121.9,549.7 1096.2,514.9 1087.2,489 C1083.8,479.2 1086.1,469.2 1087,464.4 C1090.3,447.6 1092.9,435.8 1088.8,426.6 C1086.2,421.1 1083.5,416 1070.6,412.4 Z",
    id: "Path",
    fill: "#5900CC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero",
    points: "943.2 439.9 929.9 333.6 950.1 327.3 974.9 421 1017.2 533 981.4 569.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.4,526.1 C1028.4,526.1 999.1,470.5 977.5,420.9 C977.5,420.9 967.9,432.7 940.5,440.6 L975.2,576 L1028.4,526.1 Z",
    id: "Path",
    fill: "#FFB3DA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.2,975.7 L833.8,1001.5 L752.6,1033 C752.6,1033 747.8,1018.9 795.3,983.2 L820.2,975.7 Z",
    id: "Path",
    fill: "#5900CC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.7,650.1 C752.7,650.1 733.9,636.8 723.9,633.4 C713.9,630 730.6,647.1 730.6,647.1 C730.6,647.1 708.7,647.1 696.1,649.6 C683.5,652.1 698.2,680.2 708.4,681.4 C718.6,682.5 759.1,670.5 759.1,670.5 C759.1,670.5 766.9,656.1 752.7,650.1 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.1,327.3 C950.1,327.3 961.7,312.7 962.7,307.9 C963.6,303.1 958,306.2 952.1,311.8 C952.1,311.8 957.7,285.2 955.3,281.7 C952.9,278.2 932.7,273.8 929.1,292.2 C927,302.9 929.8,333.6 929.8,333.6 C929.8,333.6 945.4,340 950.1,327.3 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 845.8,
    y1: 692.1,
    x2: 906.3,
    y2: 681.5,
    id: "Path",
    stroke: "#52CB96",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero",
    points: "891 660 759.1 670.6 752.7 650.1 878.8 623.8 967.9 574.6 996.4 607.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.2,532.4 C1087.2,532.4 1029.3,731.6 991,781.3 C991,781.3 982.6,739.8 903.5,679.3 C903.5,679.3 961.7,572 1023.4,526.8 C1085,481.7 1091.3,518.7 1087.2,532.4 Z",
    id: "Path",
    fill: "#FFB3DA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.8,562.8 C983.8,562.8 907.8,608.1 876.1,620.8 C876.1,620.8 885.7,649.2 887.1,666.8 L936.2,647.9 L975.9,590.6 L983.8,562.8 Z",
    id: "Path",
    fill: "#FFB3DA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.4,518.5 C1035.4,518.5 1006.2,534.8 983.8,562.7 C983.8,562.7 936,591.1 912.2,603.2 C888.3,615.3 876.1,620.7 876.1,620.7 C876.1,620.7 882.3,635.9 887.1,666.7 L962.8,637.2",
    id: "Path",
    stroke: "#ED85C3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.3,309.3 C537,276.5 496.9,258.8 462,258 C411.1,256.8 400.5,293.3 368.8,284.2 C330.6,273.2 337.9,217.7 291.3,202.6 C274.9,197.3 248.3,195 228.5,207.8 C199.3,226.7 196.6,240 182.6,251.8 C179.2,254.7 172.4,259.9 163.1,263.4 C143.1,270.8 123.8,264.6 113.4,261.2 C87.8,252.7 88.4,242.6 70,239.4 C54.9,236.8 35.9,240.4 22.4,251.8 C-1.9,272.3 0.4,310.4 1.5,327.2 C1.7,330.6 2,333.4 2.3,335.3 L569.4,335.3 C566.1,323.6 559.6,313 557.3,309.3 Z",
    id: "Path",
    fill: "#CED5E5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#e5c15c",
    fillRule: "nonzero",
    cx: 1223.5,
    cy: 142.9,
    r: 142.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1811.8,747.6 C1807.9,735.9 1792.2,690.5 1746.2,664.2 C1687.3,630.5 1623.9,653.8 1620.1,655.3 C1548.2,683 1534.5,758.2 1490.9,753.3 C1465.5,750.5 1465.6,724.4 1431.7,716.4 C1395.7,707.9 1349.8,726.4 1331.1,760.3 C1322.5,775.9 1320.1,794 1321.5,810 L1820.3,810 C1821.6,788.9 1817.8,765.9 1811.8,747.6 Z",
    id: "Path",
    fill: "#CED5E5",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLaunch);
export default __webpack_public_path__ + "static/media/big-launch.ffa997068994b8f1ba2951111220f1fe.svg";
export { ForwardRef as ReactComponent };